import { createRoot } from "react-dom/client";
import "./index.css";
import FrameworkSection from "./App.jsx";

function initFrameworkSection() {
  const container = document.getElementById("framework-root");
  if (container) {
    const root = createRoot(container);
    root.render(<FrameworkSection />);
  } else {
    console.warn("Framework section container #framework-root not found");
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFrameworkSection);
} else {
  initFrameworkSection();
}
